export type SeoDeafultType = {
  title: string
  description: string
  keywords: string
}
export const SEO_DEFAULTS: { [key: string]: SeoDeafultType } = {
  matchup: {
    title: 'Matchup Preview',
    description: 'Game previews and key matchups to watch for',
    keywords: 'matchup, where to watch',
  },
  player: {
    title: 'Player Profile',
    description: 'View player profile, stats, and media.',
    keywords: 'stats, player profile',
  },
}
